import { render, staticRenderFns } from "./version-history-modal.vue?vue&type=template&id=c8e0d8fa&scoped=true&"
import script from "./version-history-modal.vue?vue&type=script&lang=js&"
export * from "./version-history-modal.vue?vue&type=script&lang=js&"
import style0 from "./version-history-modal.vue?vue&type=style&index=0&id=c8e0d8fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e0d8fa",
  null
  
)

export default component.exports